import React from 'react';
import classNames from 'classnames';
import { useRadioButtonContext } from './RadioButtonContext';
import styles from './RadioButton.module.css';

function RadioButton({ value, className, onClick, children, ...rest }) {
  const { value: selectedValue, onChange } = useRadioButtonContext();
  const selected = value === selectedValue;
  const handleClick = (event) => {
    if (onClick) {
      onClick(event);
    }

    if (!selected) {
      onChange(value);
    }
  };

  return (
    <button
      type="button"
      className={classNames(styles.root, className, { [styles.selected]: selected })}
      onClick={handleClick}
      {...rest}
    >
      {children}
    </button>
  );
}

export default RadioButton;
